import generatePicker from 'antd/es/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import 'antd/es/date-picker/style/index';

const AntDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default AntDatePicker;
